// Store availability drawer: one fetch on first open, re-rendered on every size change.
(function () {
  // The endpoint takes ANY variant id of the product and answers with the whole product, keyed by variant id — one call covers every size.
  const API_BASE = 'https://tresse.e-lixir.app/product-store-availability/';

  function init() {
    const drawer = document.querySelector('[data-store-availability]');
    if (!drawer) return;

    const probeVariantId = drawer.getAttribute('data-probe-variant');
    if (!probeVariantId) return;

    const labels = {
      inStock: drawer.getAttribute('data-label-in-stock') || '',
      outOfStock: drawer.getAttribute('data-label-out-of-stock') || '',
      unavailable: drawer.getAttribute('data-label-unavailable') || '',
      sizeUnavailable: drawer.getAttribute('data-label-size-unavailable') || '',
      error: drawer.getAttribute('data-label-error') || ''
    };

    const stores = Array.prototype.slice.call(drawer.querySelectorAll('[data-store-location]'));
    const sizeButtons = Array.prototype.slice.call(drawer.querySelectorAll('[data-store-size]'));
    const message = drawer.querySelector('[data-store-message]');
    if (!stores.length) return;

    // Size radios live in the product form under the name `id`; the mobile sticky bar picks one through the same inputs. No <variant-selector> on the PDP, so no variant:change to listen to.
    const form = document.querySelector('product-form-component form');
    let request = null;

    // Read on each render rather than cached: a single-variant product has no checked radio, only the hidden input.
    function currentVariant() {
      const checked = form && form.querySelector('input[name="id"]:checked');
      return checked ? String(checked.value) : String(probeVariantId);
    }

    // Fetched once on first open so the call is not paid for by visitors who never open the drawer.
    function load() {
      if (request) return request;
      request = fetch(API_BASE + probeVariantId)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .catch(function (err) {
          request = null; // let the next open retry
          console.error('[store-availability] récupération échouée :', err);
          showMessage(labels.error);
          return null;
        });
      return request;
    }

    function refresh() {
      load().then(function (data) {
        if (data) render(data);
      });
    }

    function showMessage(text) {
      if (!message) return;
      message.textContent = text || '';
      message.hidden = !text;
    }

    // The payload lists the locations holding the size; a row matches on either join key.
    function locationsOf(entry) {
      return entry && Array.isArray(entry.locations) ? entry.locations.map(String) : [];
    }

    function storeHasStock(store, locations) {
      const handle = store.getAttribute('data-store-location');
      const locationId = store.getAttribute('data-store-location-id');
      return locations.indexOf(handle) !== -1 || (!!locationId && locations.indexOf(locationId) !== -1);
    }

    // Counts only the shops shown in the drawer: a warehouse the customer cannot visit must not keep a size alive.
    function storeStockCount(entry) {
      const locations = locationsOf(entry);
      return stores.filter(function (store) {
        return storeHasStock(store, locations);
      }).length;
    }

    // Keeps the in-drawer size buttons on the variant actually checked in the form, whoever changed it.
    // Online stock is deliberately ignored here: a size is struck through only when no shop carries it.
    function syncSizes(variantId, data) {
      sizeButtons.forEach(function (button) {
        const buttonVariantId = button.getAttribute('data-store-size');
        const isActive = buttonVariantId === variantId;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (!data) return;
        const soldOut = storeStockCount(data[buttonVariantId]) === 0;
        button.classList.toggle('is-unavailable', soldOut);
        // Le barré est décoratif : la mention masquée porte l'information aux lecteurs d'écran.
        const status = button.querySelector('[data-size-status]');
        if (status) status.textContent = soldOut ? ' — ' + labels.sizeUnavailable : '';
      });
    }

    function render(data) {
      const variantId = currentVariant();
      syncSizes(variantId, data);
      const locations = locationsOf(data[variantId]);
      let availableCount = 0;

      stores.forEach(function (store) {
        const wrapper = store.querySelector('[data-store-status]');
        const dot = store.querySelector('.store_status');
        const label = store.querySelector('.store_status_label');
        const hasStock = storeHasStock(store, locations);

        if (hasStock) availableCount++;
        if (label) label.textContent = hasStock ? labels.inStock : labels.outOfStock;
        if (dot) dot.classList.toggle('in_stock', hasStock);
        if (wrapper) wrapper.hidden = false;
        // Out of stock here: the row drops its photo and greys out, so the shops worth visiting stand out.
        store.classList.toggle('is-out-of-stock', !hasStock);

        // Visual sort through flex `order`: in-stock stores first. Nodes are never moved — re-appending them would replay the drawer's child components' connectedCallback.
        store.style.order = hasStock ? '0' : '1';
      });

      showMessage(availableCount === 0 ? labels.unavailable : '');
    }

    // 1. First open: fetch, then render.
    drawer.addEventListener('drawer:open', refresh);

    // 2. Size change while the drawer is on screen: re-render from the cached payload, no second call.
    form?.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id' && drawer.isOpen) refresh();
    });

    // 3. Size picked from inside the drawer: check the form radio and let it emit `change`, so price, add-to-cart and the ?variant= URL follow like any other size change.
    sizeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const radio = form?.querySelector('input[name="id"][value="' + button.getAttribute('data-store-size') + '"]');
        if (!radio || radio.checked) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
